export default __webpack_public_path__ + "static/media/correct_answer.c0d96c4d.svg";